export const QUEUE_MONITORING = 'Queue Monitoring';
